import { render } from "./CourseSatus.vue?vue&type=template&id=7aba8e19"
import script from "./CourseSatus.vue?vue&type=script&lang=js"
export * from "./CourseSatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__